module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Dados da Solicitação")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.dados.id) + "-" + _vm._s(_vm.dados.digito))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(_vm.dados.data)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.nome_razao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.cpf_cnpj))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.boletos.length))]), _vm._v(" "), _c('td', [_c('strong', {
    class: _vm.dados.status
  }, [_vm._v(_vm._s(_vm.dados.status == "APROVADO" &&
    _vm.dados.libera_boleto != "S" ?
    "PRÉ APROVADO" :
    _vm.dados.status))])])])])]), _vm._v(" "), _c('h4', [_vm._v("Duplicatas e Boletos")]), _vm._v(" "), (_vm.dados.libera_boleto == 'S') ? _c('button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "float": "right",
      "margin-bottom": "10px",
      "margin-left": "10px"
    },
    attrs: {
      "title": "Imprimir carnê"
    },
    on: {
      "click": function($event) {
        return _vm.getCarne(_vm.dados.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-barcode"
  }), _vm._v(" "), _c('strong', [_vm._v("Imprimir Carnê")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "float": "right",
      "margin-bottom": "10px"
    },
    attrs: {
      "title": "Imprimir duplicata"
    },
    on: {
      "click": function($event) {
        return _vm.getDuplicatas(_vm.dados.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list"
  }), _vm._v(" "), _c('strong', [_vm._v("Imprimir Duplicatas")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "float": "right",
      "margin-bottom": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "title": "Assinatura digital"
    },
    on: {
      "click": function($event) {
        _vm.showModalAssinatura = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-send"
  }), _vm._v(" "), _c('strong', [_vm._v("Assinatura digital")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dados.boletos), function(boleto, key) {
    return _c('tr', {
      key: boleto.id,
      staticClass: "odd",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(key + 1) + "ª")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(boleto.valor, 2, ",", ".")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(boleto.vencimento)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "disabled": _vm.dados.status == 'APROVADO' &&
          _vm.dados.libera_boleto != 'S',
        "title": "Gerar Boleto"
      },
      on: {
        "click": function($event) {
          return _vm.getBoleto(boleto.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-barcode"
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Upload de Duplicatas")]), _vm._v(" "), _c('vue-dropzone', {
    ref: "myVueDropzone",
    attrs: {
      "id": "dropzone",
      "options": _vm.dropzoneOptions
    }
  })], 1)]), _vm._v(" "), _vm._m(3)])])])])])]), _vm._v(" "), (_vm.showModalAssinatura) ? _c('modal-assinatura', {
    on: {
      "close": function($event) {
        _vm.showModalAssinatura = false
      },
      "assinatura": function (email, telefone) { return _vm.enviarParaAssinatura(email, telefone); }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Boletos da Garantia")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("Protocolo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }, [_vm._v("Pessoa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("Cpf/Cnpj")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Quant.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("Situação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Parcela")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "43%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "43%"
    }
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("Ação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-footer text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    staticClass: "btn btn-default"
  }, [_vm._v("Voltar")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35a44bd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operacao/garantias/impressaoDetalhe.vue
// module id = 391
// module chunks = 1